import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ICheckInResponse, IPayload } from 'src/app/models/check-in-response';

@Component({
  selector: 'app-failed-checkout-details',
  templateUrl: './failed-checkout-details.component.html',
  styleUrls: ['./failed-checkout-details.component.css']
})
export class FailedCheckoutDetailsComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<FailedCheckoutDetailsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }
  onDone() {
    this.dialogRef.close();
  }
}
